import React, { useEffect, useState } from "react";
import axios from "axios";
import { Modal, Button, Form } from "react-bootstrap";
import "./index.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer,toast } from "react-toastify";

const EditClient = ({ show, handleClose, onUserUpdated, user }) => {
  const [data, setData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    company: "",
    birthDate: "",
    country: "",
    city: "",
    image: null,
    // password: "",
    // confirmPassword: "",
    status: "Nouveau",
    Role: "client",
    KBIS: "",
    activitySector: "",
    SIRET: "",
    SIREN: "",
  });

  const roles = [
    { value: "admin", label: "Admin" },
    { value: "client", label: "Client" },
    { value: "gestionnaire", label: "Gestionnaire" },
  ];
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };
  const [showPassword, setShowPassword] = useState(false);
  const toggleConfirmPasswordVisibility = () =>
    setConfirmPasswordVisible(!confirmPasswordVisible);
  const passwordMismatch =
    data.password &&
    data.confirmPassword &&
    data.password !== data.confirmPassword;
  // Pré-remplir le formulaire avec les données du user à modifier
  useEffect(() => {
    if (user) {
      setData({
        firstname: user.firstname || "",
        lastname: user.lastname || "",
        email: user.email || "",
        phone: user.phone || "",
        company: user.company || "",
        birthDate: user.birthDate || "",
        country: user.country || "",
        city: user.city || "",
        image: null,
        // password: "",
        // confirmPassword: "",
        status: user.status || "Nouveau",
        Role: user.Role || "client",
        KBIS: user.KBIS || "",
        activitySector: user.activitySector || "",
        SIRET: user.SIRET || "",
        SIREN: user.SIREN || "",
      });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "image") {
      setData({ ...data, image: files[0] });
    } else {
      setData({ ...data, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();

    // Append each field individually
    for (const key in data) {
      if (data[key] !== undefined && data[key] !== null) {
        formData.append(key, data[key]);
      }
    }

    try {
      await axios.put(`/users/${user._id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
       toast.success("Utilisateur ajouté avec succès !", {
             autoClose: 3000,
             hideProgressBar: false,
             closeOnClick: true,
             pauseOnHover: false,
             draggable: true,
           });
       
      onUserUpdated?.();
      handleClose();
    } catch (error) {
      console.error("Erreur lors de la mise à jour :", error);
           toast.error("Échec de l'ajout de l'utilisateur !");
      
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      dialogClassName="custom-modal-width"
    >
      <Form onSubmit={handleSubmit} encType="multipart/form-data">
        <Modal.Header closeButton>
          <Modal.Title>Modifier un Utilisateur</Modal.Title>
        </Modal.Header>
        <Modal.Body className="mailing-section p-5 modal-body">
          <Form.Group className="row">
            <div className="col-md-6">
              <Form.Label className="mb-3 mt-4 secteur-title">
                Prénom
              </Form.Label>
              <Form.Control
                name="firstname"
                value={data.firstname}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-md-6">
              <Form.Label className="mb-3 mt-4 secteur-title">Nom</Form.Label>
              <Form.Control
                name="lastname"
                value={data.lastname}
                onChange={handleChange}
                required
              />
            </div>
          </Form.Group>

          <Form.Group>
            <Form.Label className="mb-3 mt-4 secteur-title">Rôle</Form.Label>
            <Form.Control
              as="select"
              name="Role"
              value={data.Role}
              onChange={handleChange}
              required
            >
              <option value="">-- Choisir un rôle --</option>
              {roles.map((role) => (
                <option key={role.value} value={role.value}>
                  {role.label}
                </option>
              ))}
            </Form.Control>
          </Form.Group>

          <Form.Group>
            <Form.Label className="mb-3 mt-4 secteur-title">Email</Form.Label>
            <Form.Control
              name="email"
              type="email"
              value={data.email}
              onChange={handleChange}
              required
              placeholder="Entrez l'adresse email"
            />
          </Form.Group>

          <Form.Group>
            <Form.Label className="mb-3 mt-4 secteur-title">
              Téléphone
            </Form.Label>
            <Form.Control
              name="phone"
              value={data.phone}
              onChange={handleChange}
              required
              placeholder="Entrez le numéro de téléphone"
            />
          </Form.Group>
          {data.Role === "client" && (
            <>
              <Form.Group className="row">
                <div className="col-md-6">
                  <Form.Label className="mb-3 mt-4 secteur-title">
                    Entreprise
                  </Form.Label>
                  <Form.Control
                    name="company"
                    value={data.company}
                    required
                    onChange={handleChange}
                    placeholder="Entrez le nom de l'entreprise"
                  />
                </div>
                <div className="col-md-6">
                  <Form.Label className="mb-3 mt-4 secteur-title">
                    Secteur d'activité
                  </Form.Label>
                  <Form.Control
                    name="activitySector"
                    value={data.activitySector}
                    onChange={handleChange}
                    required
                    placeholder="Entrez le secteur d'activité"
                  />
                </div>
              </Form.Group>

              <Form.Group className="row">
                <div className="col-md-6">
                  <Form.Label className="mb-3 mt-4 secteur-title">
                    SIRET
                  </Form.Label>
                  <Form.Control
                    name="SIRET"
                    value={data.SIRET}
                    onChange={handleChange}
                    required
                    placeholder="Entrez SIRET"
                  />
                </div>
                <div className="col-md-6">
                  <Form.Label className="mb-3 mt-4 secteur-title">
                    SIREN
                  </Form.Label>
                  <Form.Control
                    name="SIREN"
                    value={data.SIREN}
                    required
                    onChange={handleChange}
                    placeholder="Entrez SIREN"
                  />
                </div>
              </Form.Group>

              <Form.Group>
                <Form.Label className="mb-3 mt-4 secteur-title">
                  KBIS
                </Form.Label>
                <Form.Control
                  name="KBIS"
                  value={data.KBIS}
                  required
                  onChange={handleChange}
                  placeholder="Entrez KBIS"
                />
              </Form.Group>
            </>
          )}

          <div className="row">
            <div className="col-6">
              <Form.Group>
                <Form.Label className="mb-3 mt-4 secteur-title">
                  Ville
                </Form.Label>
                <Form.Control
                  name="city"
                  value={data.city}
                  onChange={handleChange}
                  required
                  placeholder="Entrez ville"
                />
              </Form.Group>
            </div>

            <div className="col-6">
              <Form.Group>
                <Form.Label className="mb-3 mt-4 secteur-title">
                  Pays{" "}
                </Form.Label>
                <Form.Control
                  name="country"
                  value={data.country}
                  onChange={handleChange}
                  required
                  placeholder="Entrez pays"
                />
              </Form.Group>
            </div>
          </div>

          {/* <div className="row">
            <div className="col-6">
              <Form.Group>
                <Form.Label className="mb-3 mt-4 secteur-title">
                  Mot de passe
                </Form.Label>

                <div className="position-relative">
                  <Form.Control
                    name="password"
                    type={passwordVisible ? "text" : "password"}
                    value={data.password}
                    onChange={handleChange}
                    required
                    placeholder="Créez un mot de passe"
                  />
                  <FontAwesomeIcon
                    icon={passwordVisible ? faEyeSlash : faEye}
                    onClick={togglePasswordVisibility}
                    className="eye-icon"
                  />
                </div>
              </Form.Group>
            </div>

            <div className="col-6">
              <Form.Group>
                <Form.Label className="mb-3 mt-4 secteur-title">
                  Confirmer le mot de passe
                </Form.Label>

                <div className="position-relative">
                  <Form.Control
                    name="confirmPassword"
                    type={confirmPasswordVisible ? "text" : "password"}
                    value={data.confirmPassword}
                    onChange={handleChange}
                    required
                    placeholder="Confirmez le mot de passe"
                  />
                  <FontAwesomeIcon
                    icon={confirmPasswordVisible ? faEyeSlash : faEye}
                    onClick={toggleConfirmPasswordVisibility}
                    className="eye-icon"
                  />
                </div>

                {passwordMismatch && (
                  <Form.Text className="text-danger">
                    Les mots de passe ne correspondent pas.
                  </Form.Text>
                )}
              </Form.Group>
            </div>
          </div> */}

          <Form.Group>
            <Form.Label className="mb-3 mt-4 secteur-title">Image</Form.Label>
            <Form.Control name="image" type="file" onChange={handleChange} />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="none"
            className="AppButton secondary"
            onClick={handleClose}
          >
            ANNULER
          </Button>
          <Button variant="none" className="AppButton primary" type="submit">
            MODIFIER
          </Button>
        </Modal.Footer>
      </Form>
      <ToastContainer autoClose={3000} />
    </Modal>
  );
};

export default EditClient;
